import React, { useState, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { Box, Tabs, Tab } from '@mui/material';
import { LintTriage } from './LintTriage';
import { TestFailures } from './TestFailures';
import { PlaywrightTests } from './PlaywrightTests';

const TAB_NAMES = ['lint-triage', 'test-failures', 'playwright-tests'];

export const DevTools: React.FC = () => {
  const location = useLocation();
  const navigate = useNavigate();

  // Get initial tab from URL hash parameter
  const getInitialTab = () => {
    const hash = location.hash;
    const params = new URLSearchParams(hash.split('?')[1] || '');
    const tabParam = params.get('tab');
    const tabIndex = TAB_NAMES.indexOf(tabParam || '');
    return tabIndex >= 0 ? tabIndex : 0;
  };

  const [tab, setTab] = useState(getInitialTab);

  // Update tab when URL changes
  useEffect(() => {
    const newTab = getInitialTab();
    if (newTab !== tab) {
      setTab(newTab);
    }
  }, [location.hash]);

  const handleTabChange = (_: React.SyntheticEvent, newValue: number) => {
    setTab(newValue);
    // Update URL hash with tab parameter
    const hash = location.hash.split('?')[0];
    navigate(`${hash}?tab=${TAB_NAMES[newValue]}`);
  };

  return (
    <Box>
      <Tabs value={tab} onChange={handleTabChange}>
        <Tab label="Lint Triage" />
        <Tab label="Test Failures" />
        <Tab label="Playwright Tests" />
      </Tabs>
      <Box sx={{ mt: 2 }}>
        {tab === 0 && <LintTriage />}
        {tab === 1 && <TestFailures />}
        {tab === 2 && <PlaywrightTests />}
      </Box>
    </Box>
  );
};
